// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sp-0";